<ng-container [matColumnDef]="columnKeyName">
    <mat-header-cell *matHeaderCellDef>
        <div class="full-height full-width flex-column flex-center-start">
            <p
                [mat-sort-header]="sortingKeyName"
                class="column-title unselectable"
                i18n
            >
                {{ title }}
            </p>
            <section class="full-width">
                @if (!entityBrowser.hideFilters) {
                <mat-form-field
                    appearance="outline"
                    class="full-width"
                >
                    <mat-date-range-input
                        [rangePicker]="pickerRange"
                        [disabled]="disabled"
                    >
                        <!--suppress HtmlFormInputWithoutLabel -->
                        <input
                            matStartDate
                            i18n-placeholder
                            placeholder="Start date"
                            #tooltip="matTooltip"
                            [matTooltipDisabled]="entityBrowser.disableTooltip"
                            (mouseover)="entityBrowser.checkInputClientVisibility($event, tooltip)"
                            [matTooltip]="
                                StartFilter || EndFilter
                                    ? (StartFilter | date : 'MM/dd/yyyy') +
                                      ' - ' +
                                      ((EndFilter ? EndFilter : PresentDate) | date : 'MM/dd/yyyy')
                                    : ''
                            "
                            [(ngModel)]="StartFilter"
                        />
                        <!--suppress HtmlFormInputWithoutLabel -->
                        <input
                            matEndDate
                            i18n-placeholder
                            placeholder="End date"
                            #tooltip="matTooltip"
                            [matTooltipDisabled]="entityBrowser.disableTooltip"
                            (mouseover)="entityBrowser.checkInputClientVisibility($event, tooltip)"
                            [matTooltip]="
                                StartFilter || EndFilter
                                    ? (StartFilter | date : 'MM/dd/yyyy') +
                                      ' - ' +
                                      ((EndFilter ? EndFilter : PresentDate) | date : 'MM/dd/yyyy')
                                    : ''
                            "
                            [(ngModel)]="EndFilter"
                        />
                    </mat-date-range-input>
                    @if (StartFilter || EndFilter) {
                    <button
                        matSuffix
                        mat-icon-button
                        class="inline-block"
                        (click)="StartFilter = EndFilter = ''; $event.stopPropagation()"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                    }
                    <mat-datepicker-toggle
                        class="inline-block"
                        matSuffix
                        [for]="pickerRange"
                    ></mat-datepicker-toggle>
                    <mat-date-range-picker #pickerRange></mat-date-range-picker>
                </mat-form-field>
                }
            </section>
        </div>
    </mat-header-cell>

    @if (cellTemplate) {
    <div>
        <mat-cell *matCellDef="let entity">
            <ng-container *ngTemplateOutlet="cellTemplate; context: { $implicit: entity }"></ng-container>
        </mat-cell>
    </div>
    } @else {
    <mat-cell *matCellDef="let entity">
        <p
            class="text-ellipsis"
            #tooltip="matTooltip"
            [matTooltip]="getEntityProperty(entity) | amFromUtc | amLocal | amDateFormat : 'D MMM YYYY, HH:mm'"
            [matTooltipDisabled]="entityBrowser.disableTooltip"
            (mouseover)="entityBrowser.checkInputClientVisibility($event, tooltip)"
        >
            {{ getEntityProperty(entity) ? (getEntityProperty(entity) | amFromUtc | amLocal | amDateFormat : 'D MMM YYYY, HH:mm') : '-' }}
        </p>
    </mat-cell>
    }
</ng-container>
